import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import FormModal from '../../Modals/FormModal';
import RecordTable from '../../Tables/record/RecordTable';
import PurchaseInfoCard from '../common/PurchaseInfoCard';
import PaymentConditionSection from '../common/PaymentConditionSection';
import SvgIcon from '../../SvgIcon/SvgIcon';
import { useSupplier } from '../../../hooks/useSupplier';
import { useExcludedSubject } from '../../../hooks/purchases/useExcludedSubject';
import { excludedSubjectProductColumns } from '../../../features/purchases/excludedSubject/excludedSubjectProductColumns';
import AddExcludedProductForm from './AddExcludedProductForm';
import AddExcludedServiceForm from './AddExcludedServiceForm';
import { useProductSettlement } from '../../../hooks/settlement/useProductSettlement';
import ProductSettlementModal from '../settlement/ProductSettlementModal';
import GeneralProductSettlementModal from '../settlement/GeneralProductSettlementModal';

const ExcludedSubjectSection = () => {
  const { suppliersDropdown, handlerGetSuppliersForDropdown } = useSupplier();

  const {
    handlerAddProduct,
    handlerDeleteProduct,
    handlerGetProductById,
    openAddProductModal,
    closeAddProductModal,
    showAddProductModal,
    showAddServiceModal,
    openAddServiceModal,
    closeAddServiceModal,
  } = useExcludedSubject();

  const {
    handlerGetSettlementsByProduct,
    handlerOpenGeneralModal,
    handlerCloseGeneralModal,
    handlerCloseSettlementModal,
    showGeneralSettlementModal,
    showSettlementModal,
  } = useProductSettlement();
  const { purchaseSettlementLoaded, form } = useSelector(
    (state: RootState) => state.basePurchase
  );

  useEffect(() => {
    handlerGetSuppliersForDropdown();
  }, []);

  const columns = useMemo(() => excludedSubjectProductColumns, []);

  const actions = useMemo(() => {
    if (purchaseSettlementLoaded) {
      return [
        {
          key: 'settle',
          onClick: (row: any) => {
            handlerGetSettlementsByProduct(form.id, row.id);
          },
        },
      ];
    }

    return [
      {
        key: 'edit',
        onClick: async (row: any) => {
          handlerGetProductById(row.id);
        },
      },
      {
        key: 'delete',
        onClick: (row: any) => {
          handlerDeleteProduct(row.id);
        },
      },
    ];
  }, [purchaseSettlementLoaded, form.id]);

  return (
    <div>
      <PurchaseInfoCard
        suppliers={suppliersDropdown}
        title="Compra Sujeto Excluido"
        maxWidth="w-full"
      />

      <RecordTable
        maxWidth="w-full"
        columns={columns}
        data={form.products}
        actions={actions}
        noDataMessage="No hay productos o servicios agregados."
        tableHeaderContent={
          <h3 className="text-lg font-medium">
            Productos o Servicios Agregados
          </h3>
        }
        tableHeaderActions={
          purchaseSettlementLoaded ? (
            <button
              onClick={handlerOpenGeneralModal}
              className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
            >
              <SvgIcon name="settle-products" />
              Asentar General
            </button>
          ) : (
            <>
              <button
                onClick={openAddProductModal}
                className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
              >
                <SvgIcon name="addCircle" />
                Agregar Producto
              </button>
              <button
                onClick={openAddServiceModal}
                className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
              >
                <SvgIcon name="serviceAdd" />
                Agregar Servicio
              </button>
            </>
          )
        }
      />

      {/* Modal Agregar Producto */}
      <FormModal
        isOpen={showAddProductModal}
        onClose={closeAddProductModal}
        title="Agregar Producto"
        maxWidth="max-w-4xl"
      >
        <AddExcludedProductForm
          onAdd={handlerAddProduct}
        />
      </FormModal>

      {/* Modal Agregar Servicio */}
      <FormModal
        isOpen={showAddServiceModal}
        onClose={closeAddServiceModal}
        title="Agregar Servicio"
        maxWidth="max-w-4xl"
      >
        <AddExcludedServiceForm onAdd={handlerAddProduct} />
      </FormModal>

      <PaymentConditionSection />

      <ProductSettlementModal
        isOpen={showSettlementModal}
        onClose={handlerCloseSettlementModal}
      />

      <GeneralProductSettlementModal
        isOpen={showGeneralSettlementModal}
        onClose={handlerCloseGeneralModal}
      />
    </div>
  );
};

export default ExcludedSubjectSection;
